<template>
<div ref="dropdownMenu">
  <ValidationProvider tag="div"
                          class="form-field field-select"
                          :class="{ required: isRequired } + ' ' + activeField"
                          :rules="rules"
                          :immediate="!!value"
                          v-slot="{ errors }">
      <div v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</div>
      <label class="control-label">{{ $t('contactUs:timeToCall.label') }}</label>
      <div class="custom-select" @blur="open = false">
        <input class="form-control selected" :class="{ open: open }"  type="text" v-model="selected" required @click="dropdownClick()" @keyup.up="dropdownClick" @keyup.down="dropdownClick" readonly>
        <SvgIcon class="custom-dropdown" :type="customDropdownIcon" />
        <div class="items" :class="{ selectHide: !open }">
          <div
            :ref="'option' + i"
            tabindex="0"
            v-for="(option, i) of options"
            :key="i"
            @click="selectOption(option)"
            @keyup.up="focusPrevOption(i)"
            @keyup.down="focusNextOption(i)"
            @keyup.enter="selectOption(option)"
            >
            {{ option.label }}
          </div>
        </div>
      </div>
  </ValidationProvider>
</div>
</template>

<script>
import BaseField from './BaseField'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'SelectCustom',
    extends: BaseField,
    components: {
        SvgIcon
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        default: {
            type: String,
            required: false,
            default: null
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            selected: this.default ? this.default : null,
            open: false,
            customDropdownIcon: 'icon_arrow_down_black',
            activeField: false
        }
    },
    methods: {
        focusPrevOption(index) {
            if (index === 0) {
                index = (this.options.length - 1)
            } else {
                index--
            }
            this.$refs['option' + index][0].focus()
        },
        focusNextOption(index) {
            if (index === (this.options.length - 1)) {
                index = 0
            } else {
                index++
            }
            this.$refs['option' + index][0].focus()
        },
        dropdownClick() {
            this.open = !this.open
            this.customDropdownIcon = this.open ? 'icon_arrow_up_black' : 'icon_arrow_down_black'
            this.$refs['option0'][0].focus()
            console.log(this.$refs['option0'][0])
        },
        documentClick(e) {
            let el = this.$refs.dropdownMenu
            let target = e.target
            if (el && (el !== target) && !el.contains(target)) {
                this.open = false
                this.customDropdownIcon = 'icon_arrow_down_black'
            }
        },
        selectOption(option) {
            this.selected = option.value
            this.open = false
            this.customDropdownIcon = 'icon_arrow_down_black'
            this.activeField = 'active'
            this.$emit('input', option.value)
        }
    },
    created() {
        document.addEventListener('click', this.documentClick)
    },
    mounted() {
        this.$emit('input', this.selected)
    }
}
</script>
